import React from 'react';
import Icon from '@atlaskit/icon';
import { useIntl } from '@atlassian/jira-intl';
import multipleFlagsIconUrl from './assets/multiple-flags.svg';
import messages from './messages.tsx';

const MultipleFlagsGlyph = () => <img src={multipleFlagsIconUrl} alt="" />;

export const MultipleFlagsIcon = () => {
	const { formatMessage } = useIntl();
	return (
		<Icon
			testId="software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.multiple-flags.icon.multiple"
			size="medium"
			glyph={MultipleFlagsGlyph}
			label={formatMessage(messages.multipleFlagsIconLabel)}
		/>
	);
};
